/**
 * @title TradeIn Completed Page - How-to box
 * @description The how-to box on the final page of the trade-in process
 * @image https://storageaccountourimbea2.blob.core.windows.net/tradein2guide/endpage-howto.png
 * @image https://storageaccountourimbea2.blob.core.windows.net/tradein2guide/endpage-labelless.png
 * @image https://storageaccountourimbea2.blob.core.windows.net/tradein2guide/endpage-pickup.png
 */
import * as React from "react";
import {Dialog, DialogContent, DialogTitle, IconButton} from "@mui/material";
import {StyledTypography} from "../../../providers/layout/LayoutProvider";
import {Images} from "../../../Images";
import {makeStyles} from "@mui/styles";
import {useRecoilValue} from "recoil";
import {LocalizationsAtom} from "../../../providers/localization/LocalizationProvider";
import {CloseIcon} from "../../../svg/SvgIcons";

type HowToDialogProps = {
   onHideDialog: () => void
   open: boolean
   code: boolean
   qr: boolean
}

export const HowToDialog = (props: HowToDialogProps) => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const classes = useStyles();

   return <Dialog onClose={props.onHideDialog} fullScreen={false} open={props.open} style={{width: '100%'}}>
      <DialogTitle sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
         <div style={{width: '100%', textAlign: 'center'}}>
            {props.code && <StyledTypography variant={"h1"}>{localizations.consumerHowToApplyCode}</StyledTypography>}
            {!props.code && <StyledTypography variant={"h1"}>{localizations.consumerHowToApplyLabel}</StyledTypography>}
         </div>
         <IconButton onClick={props.onHideDialog}>
            <CloseIcon/>
         </IconButton>
      </DialogTitle>
      <DialogContent>
         {props.qr && <div>
            <StyledTypography variant={"body1"} className={classes.spacing20} sx={{fontWeight: 'bold'}}>{localizations.consumerHowToApplyCodeQr}</StyledTypography>
            <StyledTypography variant={"body1"} className={classes.spacing10}>
               {localizations.consumerHowToApplyCodeQrDesc}
            </StyledTypography>
            <div className={classes.boxImage}>
               <img style={{width: '100px'}} src={localizations.consumerHowToApplyCodeQrImage || Images.QRCODE} alt={localizations.consumerHowToApplyCodeQr}/>
            </div>
         </div>}
         {props.code &&
            <div className={classes.box}>
               <StyledTypography variant={"body1"} className={classes.spacing20} sx={{fontWeight: 'bold'}}>{localizations.consumerHowToApplyCodeSect1}</StyledTypography>
               <StyledTypography variant={"body1"} className={classes.spacing10}>
                  {localizations.consumerHowToApplyCodeSect1Desc}
               </StyledTypography>
               <div className={classes.boxImage}>
                  <img src={localizations.consumerHowToApplyCodeSect1Image || Images.SHIPPINGCODE} alt={localizations.consumerHowToApplyCodeSect1}/>
               </div>
            </div>
         }
         {!props.code &&
            <div className={classes.box}>
               <StyledTypography variant={"body1"} className={classes.spacing20} sx={{fontWeight: 'bold'}}>{localizations.consumerHowToApplyCodeSect2}</StyledTypography>
               <StyledTypography variant={"body1"} className={classes.spacing10}>
                  {localizations.consumerHowToApplyCodeSect2Desc}
               </StyledTypography>
               <div className={classes.boxImage}>
                  <img src={localizations.consumerHowToApplyCodeSect2Image || Images.SHIPPINGLABEL} alt={localizations.consumerHowToApplyCodeSect2}/>
               </div>
            </div>
         }
      </DialogContent>
   </Dialog>
}

const useStyles = makeStyles({
   buttonBackToStart: {
      marginTop: '50px',
      color: 'white'
   },
   box: {
      marginBottom: '20px',
   },
   boxImage: {
      textAlign: 'center'
   },
   spacing20: {
      marginBottom: '15px',
      marginTop: '25px'
   },
   spacing10: {
      marginBottom: '10px'
   }

})